export default __webpack_public_path__ + "images/WA.44cd172.png";